import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import Page from "../molecules/Page"; // Upewnij się, że ścieżka jest poprawna
import { solvedDashboardTasksMessage } from "../../utils/plural"; // Upewnij się, że ścieżka jest poprawna
import "./my-react-select.css"; // Upewnij się, że ścieżka jest poprawna
import { AiOutlineQuestionCircle } from 'react-icons/ai';

// --- PRZYKŁADOWE DANE ---
// Zamiast pobierać dane z API, definiujemy je tutaj na stałe.
const mockData = {
  username: "Anna Nowak",
  problemsCount: 127,
  selectedFields: [
    { label: "Równania kwadratowe [ELO: 1350]", value: "alg-1", elo: 1350 }
  ],
  availableFields: [
    { field_id: "alg-1", field_name: "Równania kwadratowe", knowledge_level: "Algebra", user_field_elo: 1350 },
    { field_id: "alg-2", field_name: "Logarytmy", knowledge_level: "Algebra", user_field_elo: 1420 },
    { field_id: "geo-1", field_name: "Planimetria", knowledge_level: "Geometria", user_field_elo: 1180 },
    { field_id: "geo-2", field_name: "Stereometria", knowledge_level: "Geometria", user_field_elo: 1250 },
    { field_id: "calc-1", field_name: "Pochodne", knowledge_level: "Analiza", user_field_elo: 1550 },
  ],
  preferences: {
    levelModifier: 0, // 0 to "Średni"
    mobileProblems: false,
  },
};
// --- KONIEC PRZYKŁADOWYCH DANYCH ---


const DashboardDes = () => {
  // Stan komponentu inicjalizowany przykładowymi danymi
  const [username] = useState(mockData.username);
  const [selectedFields, setSelectedFields] = useState(mockData.selectedFields);
  const [availableFields] = useState(mockData.availableFields);
  const [problemsCount] = useState(mockData.problemsCount);
  const [levelModifier, setLevelModifier] = useState(mockData.preferences.levelModifier);
  const [mobileProblems, setMobileProblems] = useState(mockData.preferences.mobileProblems);
  
  // Stany odpowiedzialne za UI, bez zmian
  const [menuOpen, setMenuOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const selectRef = useRef(null);
  const tooltipRef = useRef(null);

  // useEffect do zamykania menu Select po kliknięciu na zewnątrz - pozostaje bez zmian
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // useEffect do zamykania podpowiedzi (tooltip) - pozostaje bez zmian
  useEffect(() => {
    if (!showTooltip) return;
    const handleClickOutsideTooltip = (e) => {
      const buttonClicked = e.target.closest('button[aria-label="Co to znaczy zadania bez obliczeń?"]');
      if (tooltipRef.current && !tooltipRef.current.contains(e.target) && !buttonClicked) {
        setShowTooltip(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideTooltip);
    return () => document.removeEventListener("mousedown", handleClickOutsideTooltip);
  }, [showTooltip]);


  // Funkcja grupująca opcje dla Select'a - pozostaje bez zmian
  const getGroupedMultiSelectOptions = () => {
    const filtered = availableFields.filter(
      (field) => !selectedFields.some((s) => s.value === field.field_id)
    );
    const groups = {};
    filtered.forEach((field) => {
      const group = field.knowledge_level || "Nieokreślony";
      groups[group] = groups[group] || [];
      groups[group].push({
        label: `${field.field_name} [ELO: ${field.user_field_elo}]`,
        value: field.field_id,
        elo: field.user_field_elo,
      });
    });
    return Object.keys(groups)
      .sort()
      .map((g) => ({
        label: g,
        options: groups[g].sort((a, b) => a.label.localeCompare(b.label)),
      }));
  };

  // Funkcja obsługująca zmianę w selektorze - pozostaje bez zmian
  const handleSelectChange = (selected) => {
    setSelectedFields(selected);
    setMenuOpen(true);
  };
  
  // UPROSZCZONA funkcja "rozpoczęcia rozwiązywania"
  const handleSolveProblems = (e) => {
    e.preventDefault();
    const selectedFieldIds = selectedFields.map((i) => i.value);
    const preferences = { level_modifier: levelModifier, mobile_problems: mobileProblems };

    // Zamiast wysyłać request, po prostu logujemy dane w konsoli
    console.log("--- Rozpoczynamy sesję ---");
    console.log("Wybrane kategorie (ID):", selectedFieldIds);
    console.log("Wybrane preferencje:", preferences);
    alert("Dane zostały zalogowane w konsoli! Naciśnij F12, aby je zobaczyć.");
  };

  // JSX (return) jest taki sam jak w oryginale, ale usunięto warunek "loading"
  return (
    <Page showNav>
        <>
          <div className="sm:mx-auto sm:w-full sm:max-w-sm lg:max-w-2xl xl:max-w-3xl">
            <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-gray-900">
              Cześć <span className="ph-no-capture">{username}</span>!
            </h2>
            <p className="mt-4 text-center text-gray-600">
              {solvedDashboardTasksMessage(problemsCount)}
            </p>
          </div>
          <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm lg:max-w-2xl xl:max-w-3xl">
            <form className="space-y-6" onSubmit={handleSolveProblems}>
              <div ref={selectRef}>
                <label htmlFor="categories" className="block text-sm font-medium text-gray-900">
                  Wybierz kategorie
                </label>
                <div className="mt-2">
                  <Select
                    options={getGroupedMultiSelectOptions()}
                    value={selectedFields}
                    onChange={handleSelectChange}
                    isMulti
                    placeholder="Wybierz kategorie..."
                    className="my-react-select"
                    classNamePrefix="my-react-select"
                    isSearchable
                    closeMenuOnSelect={false}
                    menuIsOpen={menuOpen}
                    onMenuOpen={() => setMenuOpen(true)}
                    onMenuClose={() => setMenuOpen(false)}
                    blurInputOnSelect={false}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Wybierz poziom trudności
                </label>
                <div className="mt-2 space-y-2 text-sm">
                  {[
                    { id: "easy", value: -300, label: "Łatwy" },
                    { id: "medium", value: 0, label: "Średni" },
                    { id: "hard", value: 300, label: "Trudny" },
                  ].map((opt) => (
                    <div key={opt.id} className="flex items-center">
                      <input
                        type="radio"
                        id={opt.id}
                        name="difficulty"
                        value={opt.value}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500"
                        checked={levelModifier === opt.value}
                        onChange={(e) => setLevelModifier(Number(e.target.value))}
                      />
                      <label htmlFor={opt.id} className="ml-2 cursor-pointer text-gray-700">
                        {opt.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex items-center space-x-2 relative">
                <input
                  id="mobile_problems"
                  type="checkbox"
                  checked={mobileProblems}
                  onChange={(e) => setMobileProblems(e.target.checked)}
                  className="h-4 w-5 text-blue-600 focus:ring-blue-500 rounded-sm"
                />
                <label
                  htmlFor="mobile_problems"
                  className="text-sm font-medium text-gray-700 cursor-pointer select-none"
                >
                  Zadania bez obliczeń
                </label>
                <button
                  type="button"
                  aria-label="Co to znaczy zadania bez obliczeń?"
                  onClick={() => setShowTooltip((prev) => !prev)}
                  className="flex h-6 w-6 items-center justify-center rounded-full text-gray-500"
                >
                  <AiOutlineQuestionCircle className="h-5 w-5" />
                </button>
                {showTooltip && (
                  <div
                    ref={tooltipRef}
                    id="mobile_problems_tooltip"
                    className="absolute z-10 top-full left-0 mt-2 w-80 rounded-lg bg-white p-3 text-xs shadow-lg ring-1 ring-black/10"
                  >
                    <p className="text-gray-700 leading-4">
                      <strong>Specjalny typ zadań</strong>, które nie wymagają
                      skomplikowanych obliczeń ani kartki i długopisu.
                      Sprawdzają Twoją znajomość podstawowych informacji oraz
                      metod rozwiązywania na prostych przykładach. Idealne do
                      autobusu zamiast scrollowania!
                    </p>
                  </div>
                )}
              </div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600"
              >
                Rozwiązuj!
              </button>
            </form>
          </div>
        </>
    </Page>
  );
};

export default DashboardDes;